import {
  ListItem,
  Theme,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/icons';
import classnames from 'classnames';
import React from 'react';
import ListText from '../../components/UI/ListText/ListText';
import MyButton from '../../components/UI/MyButton/MyButton';
import MyTable from '../../components/UI/MyTable/MyTable';
import { IFilter, IFilterState, IPlaylist } from '../../models/states';
import { formatDateTime } from '../../utilities/utilities';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    actionBtn: {
      marginRight: '1rem'
    },
    blur: {
      filter: 'blur(2px)'
    },
    breakLine: {
      whiteSpace: 'pre-wrap'
    },
    link: { textDecoration: 'none', display: 'flex' }
  });

class PlaylistSummary extends React.Component<
  IPlaylistSummaryProps,
  IPlaylistSummaryState
> {
  constructor(props: IPlaylistSummaryProps) {
    super(props);
    this.state = {
      isOpenFilters: {},
      isOpenFiltersHeadend: {}
    };
  }

  getFilteredData = (data: any, filterType: string) => {
    const { filters } = this.props;
    let missingAssets = [...Object.values(data)];
    // write separate filter for action

    Object.keys(filters[filterType]).map(filterName => {
      const filterList = filters[filterType][filterName];
      const filterListWithSetLabel = filterList.filter(filter => filter.isSet);
      const filterListWithSetLabelList = filterListWithSetLabel.map(
        (filter: any) => {
          return filter.value;
        }
      );
      if (filterListWithSetLabel.length > 0) {
        missingAssets = missingAssets.filter((missingAsset: any) => {
          if (
            filterListWithSetLabelList.indexOf(missingAsset[filterName]) !==
              -1 ||
            (Array.isArray(missingAsset[filterName]) &&
              missingAsset[filterName].filter(
                (value: any) => -1 !== filterListWithSetLabelList.indexOf(value)
              ).length > 0)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    });
    return missingAssets;
  };

  computeMissingAssets = (missingAsset: any, playlist: any) => {
    let missingAssetsData = [];
    if (Object.keys(missingAsset).length !== 0) {
      Object.keys(missingAsset).map(assetType => {
        if (missingAsset[assetType].length !== 0) {
          missingAsset[assetType] = missingAsset[assetType].map(row => {
            return {
              ...row,
              start_time: formatDateTime(row.start_time, playlist.time_zone),
              playlistID: row.playlist
                ? Object.keys(row.playlist).join(', ')
                : 'NA',
              playlistVersion: row.playlist
                ? Object.keys(row.playlist).join(', ')
                : 'NA',
              playlistType: row.playlist
                ? Object.values(row.playlist)
                    .map(playlistType => (!playlistType ? 'NA' : playlistType))
                    .join(', ')
                : 'NA'
            };
          });
        }
        missingAssetsData = missingAssetsData.concat(missingAsset[assetType]);
      });
    }
    return missingAssetsData;
  };

  renderMissingAssetsTable = (
    type: string,
    subtype: string,
    missingAssetsRows: any,
    missingAssetsHeader: any
  ) => {
    let handleFilterToggle = this.handleFilterToggleCloud;
    let handleToggleHeaderFilters = this.handleToggleHeaderFilters;
    let isOpenFilters = this.state.isOpenFilters;
    if (type === 'headend') {
      handleFilterToggle = this.handleFilterToggleHeadend;
      handleToggleHeaderFilters = this.handleToggleHeaderFiltersHeadend;
      isOpenFilters = this.state.isOpenFiltersHeadend;
    }

    if (missingAssetsRows.length === -1) {
      return null;
    } else {
      return (
        <React.Fragment>
          <ListItem>
            <Grid item xs={12}>
              <Typography>{`Missing ${type} ${subtype}`}</Typography>
            </Grid>
          </ListItem>

          <ListItem style={{ marginTop: '-2rem' }}>
            <Grid item xs={12}>
              <MyTable
                tRows={missingAssetsRows}
                tHead={missingAssetsHeader}
                order="asc"
                orderBy={''}
                multiSelect={false}
                rowsPerPage={10}
                isOpenFilters={isOpenFilters}
                onToggleHeaderFilters={handleToggleHeaderFilters}
                onToggleFilters={handleFilterToggle}
              />
            </Grid>
          </ListItem>
        </React.Fragment>
      );
    }
  };

  handleToggleHeaderFilters = (key: string) => {
    const updatedIsOpenFilter = { ...this.state.isOpenFilters };
    updatedIsOpenFilter[key] = !this.state.isOpenFilters[key];
    this.setState({
      isOpenFilters: updatedIsOpenFilter,
      isOpenFiltersHeadend: this.state.isOpenFiltersHeadend
    });
  };
  handleToggleHeaderFiltersHeadend = (key: string) => {
    const updatedIsOpenFilter = { ...this.state.isOpenFiltersHeadend };
    updatedIsOpenFilter[key] = !this.state.isOpenFiltersHeadend[key];
    this.setState({
      isOpenFilters: this.state.isOpenFilters,
      isOpenFiltersHeadend: updatedIsOpenFilter
    });
  };

  handleFilterToggleCloud = (filterName: string, filter: IFilter) => {
    this.props.onUpdateFilters('missing_assets_cloud', filterName, filter);
  };

  handleFilterToggleHeadend = (filterName: string, filter: IFilter) => {
    this.props.onUpdateFilters('missing_assets_headend', filterName, filter);
  };

  renderGridItem = (label: string, value: any, blur: boolean = false) => {
    return (
      <ListItem>
        <Grid item xs={3}>
          <Typography>{label}</Typography>
        </Grid>
        <Grid item xs={9}>
          <Typography
            className={classnames({ [this.props.classes.blur]: blur })}
          >
            {value}
          </Typography>
        </Grid>
      </ListItem>
    );
  };
  renderActions = () => {
    const { playlist, classes } = this.props;
    return (
      <ListItem>
        <Grid item xs={3}>
          <Typography>Actions</Typography>
        </Grid>
        <Grid item xs={9}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {playlist.issue_tracker_ticket.issue_id ? // &&
            // playlist.issue_tracker_ticket.status === 'open'
            null : (
              <MyButton
                className={this.props.classes.actionBtn}
                btnType={'yellow'}
                onClick={this.props.onOpenEscalateForm}
              >
                Escalate
              </MyButton>
            )}
            {!this.props.isOperator ? (
              <React.Fragment>
                <MyButton
                  className={this.props.classes.actionBtn}
                  btnType={'yellow'}
                  onClick={this.props.onOpenSnoozeForm}
                >
                  Snooze
                </MyButton>
                {playlist.issue_tracker_ticket &&
                playlist.issue_tracker_ticket.issue_id ? (
                  // &&
                  // playlist.issue_tracker_ticket.status !== 'close'
                  <a
                    href={`${globalThis.UI_CONFIG.issue_tracker_url}/${playlist.issue_tracker_ticket.issue_id}`}
                    target="_blank"
                    className={classes.link}
                  >
                    <Typography>
                      {playlist.issue_tracker_ticket.issue_id}
                    </Typography>
                    <Link style={{ paddingBottom: 5, color: '#fff' }} />
                  </a>
                ) : null}
              </React.Fragment>
            ) : null}
          </div>
        </Grid>
      </ListItem>
    );
  };
  public render() {
    const { classes, playlist } = this.props;
    // this.props.onSetMissingAssetsFilters({})
    let warnings = ['NA'];
    let errors = ['NA'];
    const blur = globalThis.UI_CONFIG.blur_data;
    const missingCloudAssetsHeader = [
      {
        label: 'Start Time',
        dataKey: 'start_time',
        isFilter: false,
        isSort: true,
        tooltip: true
      },
      {
        label: 'Asset ID',
        dataKey: 'asset_id',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: true,
        blur
      },
      {
        label: 'Type',
        dataKey: 'type',
        isFilter: true,
        filters: this.props.filters.missing_assets_cloud.type,
        isSort: false,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'State',
        dataKey: 'state',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'Occurrences',
        dataKey: 'count',
        isFilter: false,
        isSort: true,
        tooltip: true
      },
      {
        label: 'Playlist Type',
        dataKey: 'playlistType',
        isFilter: true,
        filters: this.props.filters.missing_assets_cloud.playlistType,
        isSort: false,
        tooltip: true
      },
      {
        label: 'Playlist Version',
        dataKey: 'playlistVersion',
        isFilter: true,
        filters: this.props.filters.missing_assets_cloud.playlistVersion,
        isSort: false,
        tooltip: true
      }
    ];

    const missingCloudAssetsRows = {};
    const missingHeadendAssetsRows = {};
    const missingHeadendAssetsHeader = [
      {
        label: 'Start Time',
        dataKey: 'start_time',
        isFilter: false,
        isSort: true,
        tooltip: true
      },
      {
        label: 'Headend',
        dataKey: 'headend',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: true,
        blur
      },
      {
        label: 'Asset ID',
        dataKey: 'asset_id',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: true,
        blur
      },
      {
        label: 'Type',
        dataKey: 'type',
        isFilter: true,
        filters: this.props.filters.missing_assets_headend.type,
        isSort: false,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'State',
        dataKey: 'state',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'Occurrences',
        dataKey: 'count',
        isFilter: false,
        isSort: true,
        tooltip: true
      },
      {
        label: 'Playlist Type',
        dataKey: 'playlistType',
        isFilter: true,
        filters: this.props.filters.missing_assets_headend.playlistType,
        isSort: false,
        tooltip: true
      },
      {
        label: 'Playlist Version',
        dataKey: 'playlistVersion',
        isFilter: true,
        filters: this.props.filters.missing_assets_headend.playlistVersion,
        isSort: false,
        tooltip: true
      }
    ];

    if (playlist.last_published && playlist.last_published.missing_list) {
      if (playlist.last_published.missing_list.cloud) {
        for (const assetType of Object.keys(
          playlist.last_published.missing_list.cloud
        )) {
          missingCloudAssetsRows[assetType] =
            playlist.last_published.missing_list.cloud[assetType];
        }
      }
      if (playlist.last_published.missing_list.headends) {
        for (const assetType of Object.keys(
          playlist.last_published.missing_list.headends
        )) {
          missingHeadendAssetsRows[assetType] =
            playlist.last_published.missing_list.headends[assetType];
        }
      }
      if (
        playlist.last_published.errors &&
        playlist.last_published.errors.length > 0
      ) {
        errors = playlist.last_published.errors;
      }
      if (
        playlist.last_published.warnings &&
        playlist.last_published.warnings.length > 0
      ) {
        warnings = playlist.last_published.warnings;
      }
    }
    const missingCloudAssetsData = this.computeMissingAssets(
      missingCloudAssetsRows,
      playlist
    );
    const missingHeadendAssetsData = this.computeMissingAssets(
      missingHeadendAssetsRows,
      playlist
    );

    return (
      <div className={classes.root}>
        <Grid container>
          {this.renderGridItem('Customer', playlist.customer, blur)}
          {this.renderGridItem('Feed Name', playlist.feed_name, blur)}
          {this.renderGridItem('Playlist Date', playlist.play_on)}
          {this.renderGridItem(
            'Timezone',
            playlist.time_zone ? playlist.time_zone : 'NA'
          )}
          {this.renderGridItem(
            'Playlist Id',
            playlist.last_published ? playlist.last_published.id : 'NA'
          )}
          {playlist.last_published ? (
            <React.Fragment>
              {this.renderGridItem(
                'Type',
                playlist.last_published ? playlist.last_published.ptype : 'NA'
              )}
              {this.renderGridItem(
                'Start Time',
                playlist.last_published
                  ? formatDateTime(
                      playlist.last_published.start_time,
                      playlist.time_zone
                    )
                  : 'NA'
              )}
              {this.renderGridItem(
                'End Time',
                playlist.last_published
                  ? formatDateTime(
                      playlist.last_published.end_time,
                      playlist.time_zone
                    )
                  : 'NA'
              )}
              {this.renderGridItem(
                'Broadcast Start Time',
                playlist.last_published
                  ? formatDateTime(
                      playlist.last_published.broadcast_start_time,
                      playlist.time_zone
                    )
                  : 'NA'
              )}
              {this.renderGridItem(
                'Broadcast End Time',
                playlist.last_published
                  ? formatDateTime(
                      playlist.last_published.broadcast_end_time,
                      playlist.time_zone
                    )
                  : 'NA'
              )}
            </React.Fragment>
          ) : null}
          {this.renderGridItem('Warnings', <ListText values={warnings} />)}
          {this.renderGridItem('Errors', <ListText values={errors} />)}
          {this.renderGridItem(
            'Skynet Message',
            playlist.skynet_message ? (
              <div className={classes.breakLine}>{playlist.skynet_message}</div>
            ) : (
              'NA'
            )
          )}
          {globalThis.UI_CONFIG && globalThis.UI_CONFIG.disable_issue_tracker
            ? null
            : this.renderActions()}
          {Object.keys(missingCloudAssetsData).length !== 0
            ? this.renderMissingAssetsTable(
                'cloud',
                'assets',
                this.getFilteredData(
                  missingCloudAssetsData,
                  'missing_assets_cloud'
                ),
                missingCloudAssetsHeader
              )
            : null}
          {Object.keys(missingHeadendAssetsRows).length !== 0
            ? this.renderMissingAssetsTable(
                'headend',
                'assets',
                this.getFilteredData(
                  missingHeadendAssetsData,
                  'missing_assets_headend'
                ),
                missingHeadendAssetsHeader
              )
            : null}
        </Grid>
      </div>
    );
  }
}
interface IPlaylistSummaryOwnProps extends WithStyles<typeof styles> {}
interface IPlaylistSummaryStateProps {
  filters: IFilterState;
  playlist: IPlaylist;
  isOperator: boolean;
  onOpenEscalateForm: () => any;
  onOpenSnoozeForm: () => any;
  onOpenResolveForm: () => any;
  onUpdateFilters: (
    filterType: string,
    filterName: string,
    filter: IFilter
  ) => any;
}

export interface IPlaylistSummaryState {
  isOpenFilters: {
    [key: string]: any;
  };
  isOpenFiltersHeadend: {
    [key: string]: any;
  };
}
type IPlaylistSummaryProps = IPlaylistSummaryStateProps &
  IPlaylistSummaryOwnProps;
export default withStyles(styles)(PlaylistSummary);
